import React from 'react';
import './JoinTeam.css';

const JoinTeam: React.FC = () => {
  return (
    <div className="background-gradient">
      <section className="section">
        <div className="container join-team">
        <div className="join-team__hero">
          <div className="join-team__hero-content">
            <p className="join-team__eyebrow">Кого мы ищем</p>
          </div>
        </div>

        <div className="join-team__grid">
          <article className="join-team__role card">
            <div className="join-team__role-header">
              <span className="join-team__role-icon">✦</span>
              <h3 className="join-team__role-title">UX/UI дизайнер</h3>
            </div>
            <ul className="join-team__role-list">
              <li>Проектирование пользовательских сценариев и прототипов (Figma)</li>
              <li>Создание интерфейсов для web/mobile, работа с дизайн системой</li>
              <li>Подготовка макетов к разработке, взаимодействие с разработчиками</li>
            </ul>
          </article>

          <article className="join-team__role card">
            <div className="join-team__role-header">
              <span className="join-team__role-icon">✦</span>
              <h3 className="join-team__role-title">Backend разработчик</h3>
            </div>
            <ul className="join-team__role-list">
              <li>Разработка и поддержка серверной части, API и интеграций</li>
              <li>Проектирование архитектуры, работа с базами данных</li>
              <li>Оптимизация производительности, безопасность, логирование/мониторинг</li>
            </ul>
          </article>

          <article className="join-team__role card">
            <div className="join-team__role-header">
              <span className="join-team__role-icon">✦</span>
              <h3 className="join-team__role-title">Android разработчик</h3>
            </div>
            <ul className="join-team__role-list">
              <li>Разработка нативного Android приложения</li>
              <li>Интеграция API, работа с UI и состояниями, тестирование</li>
              <li>Публикация и поддержка релизов, улучшение производительности</li>
            </ul>
          </article>
        </div>

        <div className="join-team__hero-card join-team__hero-card--footer card">
          <div className="join-team__hero-glow" />
          <div className="join-team__hero-grid" />
          <div className="join-team__hero-content-card">
            <p className="join-team__hero-label">Отклик</p>
            <p className="join-team__hero-text">
              <a className="join-team__telegram" href="https://t.me/DaniilSnejniy" target="_blank" rel="noreferrer" aria-label="Telegram">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M22.5 2.9L1.9 11.3c-1 .4-1 1.8.1 2.2l5.2 1.7 2 6.2c.3 1 1.6 1.2 2.2.4l3.1-4.1 5.7 4.2c.9.6 2.1.1 2.3-1L23.9 4.7c.3-1.1-.5-2.1-1.4-1.8zM9.3 14.8l-.7 3.1-.9-2.9 10.2-7.1-8.6 6.9z" />
                </svg>
              </a>
              @DaniilSnejniy
            </p>
            <p className="join-team__hero-subtext">Напишите нам и приложите портфолио (для дизайнера) или ссылки на проекты/GitHub (для разработчиков).</p>
          </div>
        </div>
        </div>
      </section>
    </div>
  );
};

export default JoinTeam;
